import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { useDispatch, useSelector } from "react-redux";
import { handleCustomerData } from "../../../action/quote_order/leadcustomer.action.js";
const options = {
	paginationSize: 4,
	firstPageText: "First",
	lastPageText: "Last",
	nextPageTitle: "next",
	prePageTitle: "prev",
	hideSizePerPage: true
};

const rowEvents = {
	onClick: (e, row, rowIndex) => {}
};

const columns = [
	{
		dataField: "first_name",
		text: "Name"
	},
	{
		dataField: "email",
		text: "Email"
	},
	{
		dataField: "mobile_no",
		text: "Phone"
	},
	{
		dataField: "owner_name",
		text: "Owner"
	}
];

const LeadCustomerTable = () => {
	const { searchData, searchType } = useSelector((state) => state.leadcustomerReducer);
	const dispatch = useDispatch();
	return (
		<div className="lead-customer-table without-left-border rb-data-table">
			{searchData != undefined && Object.keys(searchData).length > 0 && searchData[0] != "No" ? (
				<BootstrapTable
					bootstrap4
					keyField="id"
					rowEvents={{
						onClick: (e, row, rowIndex) => {
							dispatch(handleCustomerData(e, row, rowIndex));
						}
					}}
					data={searchData}
					columns={columns}
					pagination={paginationFactory(options)}
				/>
			) : (
				<div className="no-record-found-table">
					<div className="no-record-icon">
						<span className="icon-ico-no-result"></span>
					</div>
					<div className="no-record-info">No records found in the {searchType}</div>
				</div>
			)}
		</div>
	);
};

export default LeadCustomerTable;
